import{addToCartTypes} from '../../constants';
export const addScenarioToCart = (data) =>{
  console.log("in action")
  return {
    type:"ADD_ITEMS",
    count : data.count,
    items : data.items,
  }
}

export const addGroupToCart = (obj) =>{
  return{
    type : "ADD_GROUP",
    group : obj.group,
  }
}


export const updateShoppingCart = (obj) =>{
  return{
    type : "UPDATE_CART",
    count : obj.count,
    items : obj.items,
  }
}

export const addBaseScenarioToCart = (data) =>{
  console.log("in base action",data)
  return {
    type:addToCartTypes().addBaseItems,
    count : data.count,
    items : data.items,
  }
}

export const getADClientList = (data) =>{
  return {
    type:addToCartTypes().getADClients,
    ad_client_list : data.ad_client_list,
  }
}
